import React from "react";
import { css, useTheme } from "@emotion/react";
import ContentCombine from "core/Components/ContentCombine";

type Props = {
    text: string,
    className?: string,
};

const ProductText: React.FC<Props> = ({
    text,
    className = ""
}) => {
    const theme = useTheme();

    const style = css`
        text-align: center;
        justify-content: center;
        width: 70%;
        font-size: 22px;
        line-height: 30px;
        min-height: 60px;
        height: fit-content;
        margin: 0 0 10px;

        ${theme.breakpoints.up("5xl")} {
            font-size: 30px;
            line-height: 36px;
        }

        ${theme.breakpoints.between("3xl", "4xl")} {
            font-size: 25px;
            line-height: 34px;
        }

        ${theme.breakpoints.only("xl")} {
            font-size: 19px;
            line-height: 26px;
        }

        ${theme.breakpoints.only("lg")} {
            font-size: 22px;
            line-height: 30px;
        }

        ${theme.breakpoints.down("md")} {
            font-size: 14px;
            line-height: 19px;
        }
    `;

    return (
        <ContentCombine css={style} className={className}>{text}</ContentCombine>
    );
};

export default ProductText;
